/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Sync_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "The most common cause is an expired connection. Reconnect the space from its settings, then sync again. If it still fails, an administrator may need to check..." |
*
* @param {Uno_Edu_Space_Sync_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_sync_chip2_answer = /** @type {((inputs?: Uno_Edu_Space_Sync_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Sync_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die häufigste Ursache ist eine abgelaufene Verbindung. Verbinden Sie den Space in seinen Einstellungen neu und synchronisieren Sie erneut. Schlägt es weiterhin fehl, muss möglicherweise ein Administrator den Connector prüfen.")
	return /** @type {LocalizedString} */ ("The most common cause is an expired connection. Reconnect the space from its settings, then sync again. If it still fails, an administrator may need to check the connector.")
});